import { FlexboxDirection, FlexboxAlignItems, FlexboxJustifyContent, FlexboxGapSize } from '../types/flexbox'

interface DefaultPropValues {
  direction: FlexboxDirection,
  align: FlexboxAlignItems,
  justify: FlexboxJustifyContent,
  gap: FlexboxGapSize
}

const useFlexbox = (defaults?: Partial<DefaultPropValues>) => {
  const props = {
    direction: {
      type: String as () => FlexboxDirection,
      required: false,
      default: defaults?.direction ?? FlexboxDirection.Row,
      validator: (value: FlexboxDirection) => Object.values(FlexboxDirection).includes(value)
    },
    align: {
      type: String as () => FlexboxAlignItems,
      required: false,
      default: defaults?.align ?? FlexboxAlignItems.Center,
      validator: (value: FlexboxAlignItems) => Object.values(FlexboxAlignItems).includes(value)
    },
    justify: {
      type: String as () => FlexboxJustifyContent,
      required: false,
      default: defaults?.justify ?? FlexboxJustifyContent.Stretch,
      validator: (value: FlexboxJustifyContent) => Object.values(FlexboxJustifyContent).includes(value)
    },
    gap: {
      type: String as () => FlexboxGapSize,
      required: false,
      default: defaults?.gap ?? FlexboxGapSize.Small,
      validator: (value: FlexboxGapSize) => Object.values(FlexboxGapSize).includes(value)
    },
    isContainer: {
      type: Boolean as () => boolean,
      required: false,
      default: true
    }
  }

  return {
    props
  }
}

export default useFlexbox
